import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 md:py-16 px-4 md:px-6" data-id="element-123">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} whileHover={{
      boxShadow: '0 10px 30px -10px rgba(200,162,74,0.2)',
      borderColor: '#c8a24a'
    }} className="max-w-3xl mx-auto bg-white rounded-2xl p-6 md:p-12 text-center border border-cream-200 shadow-sm relative overflow-hidden transition-all" data-id="element-124">
        <div className="absolute top-0 left-0 w-full h-1.5 md:h-2 bg-gold-500" data-id="element-125"></div>
        <ShieldCheck className="w-12 h-12 md:w-16 md:h-16 text-gold-500 mx-auto mb-4 md:mb-6" data-id="element-126" />
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-navy-900 mb-3 md:mb-4" data-id="element-127">
          7 días de garantía total
        </h2>
        <p className="text-sm md:text-lg text-navy-900/70 mb-5 md:mb-6 leading-relaxed" data-id="element-128">
          Descargás los tomos, probás los recursos en tu próximo encuentro. Si
          no es lo que esperabas, te devolvemos el 100% del dinero. Sin
          preguntas, sin formularios, sin drama.
        </p>
        <div className="inline-block bg-cream-100 text-navy-900 font-medium px-3 py-1.5 md:px-4 md:py-2 rounded-full text-xs md:text-sm border border-cream-200" data-id="element-129">
          Tasa de devoluciones menor al 1%
        </div>
      </motion.div>
    </section>;
}